import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/contexts/AuthContext";
import { WSProvider } from "@/contexts/WSContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

const Landing = lazy(() => import("@/pages/Landing"));
const Login = lazy(() => import("@/pages/Login"));
const SuperAdmin = lazy(() => import("@/pages/SuperAdmin"));
const Dashboard = lazy(() => import("@/pages/admin/Dashboard"));
const Users = lazy(() => import("@/pages/admin/Users"));
const Teams = lazy(() => import("@/pages/admin/Teams"));
const CountJobs = lazy(() => import("@/pages/admin/CountJobs"));
const Reports = lazy(() => import("@/pages/admin/Reports"));
const Messages = lazy(() => import("@/pages/admin/Messages"));
const CountView = lazy(() => import("@/pages/counter/CountView"));

const Loading = () => (
  <div className="min-h-screen bg-slate-900 flex items-center justify-center">
    <div className="w-8 h-8 border-2 border-green-500 border-t-transparent rounded-full animate-spin" />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <WSProvider>
          <Suspense fallback={<Loading />}>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/super-admin" element={
                <ProtectedRoute allowedRoles={["super_admin"]}>
                  <SuperAdmin />
                </ProtectedRoute>
              } />
              <Route path="/admin/dashboard" element={
                <ProtectedRoute allowedRoles={["admin", "super_admin"]}>
                  <Dashboard />
                </ProtectedRoute>
              } />
              <Route path="/admin/users" element={
                <ProtectedRoute allowedRoles={["admin", "super_admin"]}>
                  <Users />
                </ProtectedRoute>
              } />
              <Route path="/admin/teams" element={
                <ProtectedRoute allowedRoles={["admin", "super_admin"]}>
                  <Teams />
                </ProtectedRoute>
              } />
              <Route path="/admin/count-jobs/new" element={
                <ProtectedRoute allowedRoles={["admin", "super_admin"]}>
                  <CountJobs />
                </ProtectedRoute>
              } />
              <Route path="/admin/reports/:jobId" element={
                <ProtectedRoute allowedRoles={["admin", "super_admin"]}>
                  <Reports />
                </ProtectedRoute>
              } />
              <Route path="/admin/messages" element={
                <ProtectedRoute allowedRoles={["admin", "super_admin"]}>
                  <Messages />
                </ProtectedRoute>
              } />
              <Route path="/count" element={
                <ProtectedRoute allowedRoles={["counter", "count_assistant", "admin"]}>
                  <CountView />
                </ProtectedRoute>
              } />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Suspense>
          <Toaster position="top-right" theme="dark" />
        </WSProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
